import { useState } from "react";
import "../../styles/Onboarding.css";

import OnboardingScreen1 from "./OnboardingScreen1";
import OnboardingScreen2 from "./OnboardingScreen2";
import OnboardingScreen3 from "./OnboardingScreen3";
import OnboardingScreen4 from "./OnboardingScreen4";

const screens = [
  OnboardingScreen1,
  OnboardingScreen2,
  OnboardingScreen3,
  OnboardingScreen4,
];

export default function Onboarding({ onFinish }) {
  const [activeIndex, setActiveIndex] = useState(0);

  const isLast = activeIndex === screens.length - 1;
  const CurrentScreen = screens[activeIndex];

  const handleNext = () => {
    if (isLast) {
      localStorage.setItem("chatshop_onboarding_seen", "true");
      onFinish?.();
      return;
    }
    setActiveIndex((prev) => prev + 1);
  };

  const handleSkip = () => {
    localStorage.setItem("chatshop_onboarding_seen", "true");
    onFinish?.();
  };

  return (
    <div className="onboarding">
      <div className="onboardingCard">

        {/* 🔥 КНОПКА ПРОПУСТИТИ */}
        <button className="onboardingSkip" onClick={handleSkip}>
          Пропустити
        </button>

        <div className="onboardingCounter">{activeIndex + 1} / 4</div>

        <div className="onboardingProgress">
          {screens.map((_, index) => (
            <span
              key={index}
              className={`onboardingProgressItem ${
                index === activeIndex ? "active" : ""
              }`}
            />
          ))}
        </div>

        <CurrentScreen />

        <button className="onboardingNextBtn" onClick={handleNext}>
          {isLast ? "Почати" : "Далі"}
        </button>
      </div>
    </div>
  );
}